import { ReactElement } from 'react';
import PerformableGroupForm from '~/components/performable/PerformableGroupForm';
import Sections from '~/components/layout/Sections';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { McmDroneInclude, McmPhotoInclude } from '~/tenants/mcm/package/common';
import McmPhotoConfig, { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVideoConfig, { McmVideoOrientation, McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';

export default function McmPackageCrossroadsPlatinumForm(): ReactElement {
  return (
    <Sections>
      <TenantPackageIncludes>
        <McmPhotoInclude />
        <McmDroneInclude type={McmDroneType.VIDEO_PHOTO} />
      </TenantPackageIncludes>
      <PerformableGroupForm performable={McmPhotoConfig}>
        <ZodFieldHidden name="type" value={McmPhotoType.INTERIOR_EXTERIOR} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmZillowConfig} />
      <PerformableGroupForm performable={McmDroneConfig}>
        <ZodFieldHidden name="type" value={McmDroneType.VIDEO_PHOTO} />
        <ZodFieldHidden name="daytime" value="true" />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmVideoConfig}>
        <ZodFieldHidden name="type" value={McmVideoType.PREMIUM} />
        <ZodFieldHidden name="orientation" value={McmVideoOrientation.HORIZONTAL} />
      </PerformableGroupForm>
    </Sections>
  );
}
